import "./Analytics.scss";
import { Button, Card, Col, Layout, Row, Skeleton, Statistic } from "antd";
import React, { useEffect } from "react";
import MenuBar from "../../../components/Menu/MenuBar";
import Footer from "../../../components/Footer/Footer";
import AnalyticForm from "../../../components/Forms/AnalyticForm";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  LikeOutlined,
  CalendarOutlined,
  ExportOutlined,
} from "@ant-design/icons";
import store from "../../../../controllers/store";
import { analytics } from "../../../../controllers/store/actions/analytics/get-analytics-actions";
import { Query } from "../../..";
import { useSelector } from "react-redux";
import BarChart from "../../../components/charts/BarChart";
import { exportAnalyticsToExcel } from "../../../../shared/util";
const { Header, Content } = Layout;
const dispatch = store.dispatch;
const Metrics: React.FC = () => {
  const analyticsState = useSelector((state: any) => state.analytics);

  useEffect(() => {
    dispatch(analytics({} as Query));
  }, []);

  return (
    <Layout className="metrics-layout">
      <MenuBar />
      <Header className="bg-header-profile" />
      <Content className="metrics-content">
        <Card style={{ backgroundColor: "#e9e9e9" }} className="metrics-card">
          <AnalyticForm
            onSelectCitiesChange={() => {
              throw new Error("Function not implemented.");
            }}
            onClearActorType={() => {
              throw new Error("Function not implemented.");
            }}
            onClearCity={() => {
              throw new Error("Function not implemented.");
            }}
          />
          <Row gutter={[8, 8]}>
            <Skeleton
              loading={analyticsState.isLoading}
              active
              className="full-width"
            >
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Solicitudes"
                    value={
                      analyticsState?.analytics?.connectionRequests
                        ?.totalCount || 0
                    }
                    prefix={<LikeOutlined />}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Solicitudes de conexion pendientes"
                    value={
                      analyticsState?.analytics?.connectionRequests?.pending
                    }
                    suffix={` / ${analyticsState?.analytics?.total || 0}`}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Solicitudes aceptadas"
                    value={
                      analyticsState?.analytics?.connectionRequests?.accepted
                    }
                    valueStyle={{ color: "#3f8600" }}
                    prefix={<ArrowUpOutlined />}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Solicitudes rechazadas"
                    value={analyticsState?.analytics?.rejected}
                    valueStyle={{ color: "#cf1322" }}
                    prefix={<ArrowDownOutlined />}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Eventos creados"
                    value={analyticsState?.analytics?.events?.total || 0}
                    prefix={<CalendarOutlined />}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Eventos vigentes"
                    value={analyticsState?.analytics?.events?.current || 0}
                    valueStyle={{ color: "#3f8600" }}
                    prefix={<CalendarOutlined />}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card bordered={false}>
                  <Statistic
                    title="Eventos ejecutados"
                    valueStyle={{ color: "#cf1322" }}
                    value={analyticsState?.analytics?.events?.past || 0}
                    prefix={<CalendarOutlined />}
                  />
                </Card>
              </Col>
              <Col span={12}>
                <Card bordered={false}>
                  {analyticsState?.analytics?.eventsMonthlyReport ? (
                    <BarChart
                      seriesColor="#ff4d4f"
                      seriesTitle="Eventos"
                      charTitle="Eventos"
                      data={analyticsState?.analytics?.eventsMonthlyReport}
                    />
                  ) : null}
                </Card>
              </Col>
              <Col span={12}>
                <Card bordered={false}>
                  {analyticsState?.analytics?.connectionRequestMonthlyReport ? (
                    <BarChart
                      seriesColor="#EF7A4C"
                      charTitle="Conexiones"
                      seriesTitle="Solicitud de Conexiones"
                      data={
                        analyticsState?.analytics
                          ?.connectionRequestMonthlyReport
                      }
                    />
                  ) : null}
                </Card>
              </Col>
            </Skeleton>
          </Row>
          {analyticsState?.analytics ? (
            <>
              <br />
              <br />
              <Row justify="center">
                <Col>
                  <Button
                    size="large"
                    type="primary"
                    icon={<ExportOutlined />}
                    onClick={() =>
                      exportAnalyticsToExcel(analyticsState?.analytics)
                    }
                  >
                    Exportar a xlsx
                  </Button>
                </Col>
              </Row>
            </>
          ) : null}
        </Card>
      </Content>
      <Footer />
    </Layout>
  );
};

export default Metrics;
